import React from 'react';
import { Box, Card, Image, Text } from '@zillow/constellation-10';

import type Comparables from '../models/Comparables';

export interface ListingCardProps {
  listing: Comparables;
}
const ListingCard: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<ListingCardProps>>> = ({
  listing,
}) => {
  const { propertyPhotos, bubblePrice, pricePerSqft, beds, baths, sqft, url, isActive } = listing;
  const propertyPhoto = propertyPhotos && propertyPhotos[0] && propertyPhotos[0].medium;
  return (
    <Card tone="neutral" css={{ display: 'flex', flexDirection: 'row', height: '2500' }}>
      <Box css={{ alignItems: 'flex-start', overflow: 'hidden' }}>
        {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 69px` falls between `1700` (68px) and `1800` (72px) on the numeric sizes scale; `width: 69px` falls between `1700` (68px) and `1800` (72px) on the numeric sizes scale */}
        <Image src={propertyPhoto} alt="property photo" css={{ height: '69px', width: '69px', objectFit: 'cover' }} />
      </Box>
      <Box css={{ display: 'flex', flexDirection: 'column', paddingLeft: '200' }}>
        <Text asChild textStyle="heading-xs">
          {isActive ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {bubblePrice}/mo
            </a>
          ) : (
            <span>{bubblePrice}/mo</span>
          )}
        </Text>
        {pricePerSqft && <Text textStyle="body-sm">{pricePerSqft} per sq. ft.</Text>}
        <Text textStyle="body-sm">
          {beds ? beds : '--'} bd, {baths ? baths : '--'} ba, {sqft ? sqft : '--'} sq. ft.
        </Text>
      </Box>
    </Card>
  );
};

export default ListingCard;
